import { EventEmitter, Injectable, OnDestroy } from '@angular/core';
import { asyncScheduler, Subscription } from 'rxjs';
import { throttleTime, delay } from 'rxjs/operators';

@Injectable({
  providedIn: 'any',
})
export class EmailPreviewRefreshService implements OnDestroy {
  /** Emits on all events received from .refresh() */
  unthrottledRefreshEmitter$: EventEmitter<null> = new EventEmitter<null>();

  /** Emits AFTER throttling for 800ms */
  public refreshEmitter$: EventEmitter<null> = new EventEmitter<null>();

  /** Emits BEFORE throttling for 800ms */
  public refreshStartedEmitter$: EventEmitter<null> = new EventEmitter<null>();

  private subscriptions: Subscription[] = [];

  constructor() {
    // Default refreshEmitter
    this.subscriptions.push(
      this.unthrottledRefreshEmitter$
        .pipe(throttleTime(800, asyncScheduler, { trailing: true }), delay(50))
        .subscribe(() => {
          this.refreshEmitter$.emit();
        }),
    );

    // refreshStartedEmitter
    this.subscriptions.push(
      this.unthrottledRefreshEmitter$.pipe(throttleTime(800, asyncScheduler, { leading: true })).subscribe(() => {
        this.refreshStartedEmitter$.emit();
      }),
    );
  }

  ngOnDestroy(): void {
    this.subscriptions.forEach((sub) => sub.unsubscribe());
  }

  refresh(): void {
    this.unthrottledRefreshEmitter$.emit();
  }
}
